import axios from 'axios'
/**
 * 请求吉客云接口数据
 * @param {Object} data 请求数据
 * @param {Object} callback 回调方法
 */
function jackyunPost(data, callback) {
    let reqUrl = 'https://jmall.jackyun.com/jmc/JackYunApi/Post';

   //设置吉客云会员名
	data.target_member_name = '66991';
	data.sub_member_name = '';
	// 客户端名称
	data.client_name = "pc";

    // 请求接口
    axios.post(reqUrl, data).then((response) => {
        // console.info(response);
        if (response.status == 200) {
            callback && callback(response.data)
        }

        try {
            // 签名异常导致的请求，打印错误日志
            if (response.data.code != 200 && response.data.msg.includes("签名")) {
                console.error(`签名验证失败（${data.method}）:`, data, response.data);
            }
        } catch (e) { }
    }).catch((error) => {
        console.info(error);
    });
}

/**
 * 根据域名查询吉克号信息
 */
const getUserInfoByDomainName = (domainName) => {
	return new Promise((resolve, reject) => {
		jackyunPost({
			method: "jmall.auth.getuserinfobydomainname",
			jsonStr: JSON.stringify({hostName:domainName})
		}, (res) => {
			let data = {};
			if (res.code == 200) {
				data = res.result.data || {};
			}
			resolve(data);
		});
	});
}

export {
    jackyunPost,
    getUserInfoByDomainName
}